import { formatInTimeZone as formatTz } from 'date-fns-tz';

const isValidDate = (date?: string | Date) => {
  if (!date) {
    return false;
  }

  return typeof date === 'string' || (date instanceof Date && !!date.getDate());
};

export const formatInTimezone = (date: Date | string = '', timeZoneName: string, dateFormat?: string): string => {
  if (!isValidDate(date) || !dateFormat) {
    return '';
  }

  return formatTz(date, timeZoneName, dateFormat);
};

export const calculateAgeInMinutes = (dob) => {
  let diff = (new Date(dob).getTime() - new Date().getTime()) / 1000;

  diff /= 60;

  return Math.abs(Math.round(diff));
};
